import axios from 'axios'

const getAxiosWithIE11Config = (isIE11, baseUrl) => {
  if (isIE11) {
    return axios.create({
      baseURL: baseUrl,
      headers: {
        'Cache-Control': 'no-store'
      }
    })
  }
  return axios.create({
    baseURL: baseUrl,
    headers: {}
  })
}

const handleUninitializedAxiosProvider = (isInitialized) => {
  if (!isInitialized) {
    throw new Error('Please initialize Axios Provider')
  }
}

export default class AxiosProvider {
  static init (isIE11) {
    this.isInitialized = true
    this.isIE11 = isIE11
  }

  static getBeepAxios () {
    handleUninitializedAxiosProvider(this.isInitialized)
    if (!this.beepAxios) {
      this.beepAxios = getAxiosWithIE11Config(this.isIE11, process.env.VUE_APP_BEEP_URL)
    }
    return this.beepAxios
  }

  static getLocationAxios () {
    handleUninitializedAxiosProvider(this.isInitialized)
    if (!this.locationAxios) {
      this.locationAxios = getAxiosWithIE11Config(this.isIE11, process.env.VUE_APP_LOCATION_API)
    }
    return this.locationAxios
  }
}
